import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=04476c34&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=04476c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04476c34",
  null
  
)

export default component.exports